import enCommon from "./en/common";
import enHome from "./en/home";
import enPages from "./en/pages";
import enPages2 from "./en/pages2";
import guCommon from "./gu/common";
import guPages from "./gu/pages";

const en = { ...enCommon, home: enHome, pages: { ...enPages, ...enPages2 } };
const guRaw = { ...guCommon, pages: guPages };

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

// Gujarati falls back to English for any key not yet translated.
const deepMerge = (base, override) => {
  const out = Array.isArray(base) ? [...base] : { ...base };
  Object.keys(override || {}).forEach((k) => {
    out[k] = isObj(base?.[k]) && isObj(override[k]) ? deepMerge(base[k], override[k]) : override[k];
  });
  return out;
};

export const dictionaries = { en, gu: deepMerge(en, guRaw) };
export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "gu", label: "ગુજરાતી", short: "GU" },
];
